import { useQuery } from '@tanstack/react-query'
import { getAdminOperationsAlert } from '../lib/endpoints/adminOperations'
import { pollInterval } from '../lib/pollBackoff'
import { qk } from '../lib/queryKeys'

export function useAdminOperationsAlert(enabled: boolean) {
  return useQuery({
    queryKey: qk.adminOperationsAlert(),
    queryFn: getAdminOperationsAlert,
    enabled,
    refetchInterval: (query) => pollInterval(query.state.error, 30_000),
    staleTime: 15_000,
    // Inherit the shared retry policy: a 429 must cool down, not retry at once.
  })
}
